export class RateLockTermsCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria(params) {
    return this.#http.get('/api/rate-lock-term-criteria', { params });
  }

  async createCriteria(body) {
    return this.#http.post('/api/rate-lock-term-criteria', body);
  }

  async editCriteria({ lockTermCriteriaId, ...body }) {
    return this.#http.put(`/api/rate-lock-term-criteria/${lockTermCriteriaId}`, body);
  }

  async deleteCriteria({ lockTermCriteriaId }) {
    return this.#http.delete(`/api/rate-lock-term-criteria/${lockTermCriteriaId}`);
  }
}
